import { useContext } from 'react';
import ThemeContext from '@contexts/ThemeContext';
import { ThemeContextValue } from '@type/theme';

/**
 * Custom hook to access theme context
 * Must be used within a ThemeProvider
 */
export const useTheme = (): ThemeContextValue => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export default useTheme;
